import { Typography } from "@packages/ds";
import styled from "styled-components";

export const RequestBandWidthContainer = styled.div`
  display: flex;
  gap: 24px;
  background-color: var(--section-snow-background-color, var(--snow));
  padding: 32px 24px;
  padding-bottom: 53px;
  border-radius: 4px;
  margin-bottom: 32px;
  flex-wrap: nowrap;

  hr {
    height: auto;
    margin: 7px 10px -12px 10px;
    border: 0.5px solid
      var(--divider-periwinkle-grey-background-color, var(--periwinkle-grey));
  }

  @media screen and (max-width: 1100px) {
    flex-direction: column;

    hr {
      margin: 32px 0 12px 0;
    }
  }
`;

export const SkeletonContainer = styled.div`
  div.logs-skeleton-layout {
    margin-left: 0;
  }
  .main-skeleton {
    height: 290px;
  }
`;

export const RequestBandWidthSkeletonContainer = styled(
  RequestBandWidthContainer
)`
  padding: 0;
  background-color: transparent;
  hr {
    margin: 16px 10px 16px 10px;
  }

  @media screen and (max-width: 1100px) {
    hr {
      margin: 14px 0 12px 0;
    }
    gap: 24px;
  }
`;

export const ChartTitle = styled(Typography.Title)`
  font-size: 15px;
  line-height: 24px;
  .sum {
    font-size: 18px;
  }
`;

export const ChartTitleLight = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--section-granite-color, var(--granite));
`;

export const ChartTitleContainer = styled.div`
  gap: 8px;
  display: flex;
  justify-content: space-between;

  .sum {
    align-self: flex-end;
  }
`;

export const ChartTitleList = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`;

export const HeaderSection = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 24px;

  position: sticky;
  top: -1px;

  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease,
    transform 0.3s ease,
    opacity 0.3s ease;

  &.is-stuck {
    background: var(--mode-bg-neutral-weakest, var(--snow));
    padding: 16px;
    border-radius: 8px;
    z-index: 1;
    box-shadow: 0px 6px 24px 0px
      var(--mode-shadow-default, rgba(186, 192, 201, 0.4));
    transform: translateY(0);
    .last-updated-container {
      display: none;
    }
  }
`;

export const PageTitle = styled(Typography.Title)`
  margin-bottom: 8px;
  font-size: 20px;
  display: flex;
  gap: 12px;
`;

export const ChartFilterContainer = styled.div`
  display: flex;
  gap: 8xp;
`;

export const FlexWrapper = styled.div`
  flex: 1;
`;

export const LogsExplorer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${"var(--modal-snow-background-color,var(--snow))"};
  padding: 20px;
`;
